import React, { useState } from "react";
import { Upload, Card, Button, Row, Col } from "antd";
import { InboxOutlined, CheckCircleOutlined } from "@ant-design/icons";
import type { UploadFile } from "antd";

const { Dragger } = Upload;

interface FileUploadSectionProps {
  onUpload: (fileList: UploadFile[]) => Promise<void>;
  loadingUpload: boolean;
  processingStatus: string;
  processingSteps: string[];
  accessible: boolean;
}

const FileUploadSection: React.FC<FileUploadSectionProps> = ({
  onUpload,
  loadingUpload,
  processingStatus,
  processingSteps,
  accessible
}) => {
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  const handleUpload = () => {
    onUpload(fileList);
  };

  return (
    <Row justify="center" style={{ marginBottom: "24px" }}>
      <Col xs={24} sm={24} md={18} lg={16} xl={14}>
        <Card title="Upload Medical Files" style={{ width: "100%" }}>
          <Dragger
            multiple
            fileList={fileList}
            beforeUpload={() => false}
            onChange={({ fileList }) => setFileList(fileList)}
            disabled={loadingUpload || !accessible}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              Click or drag files here to upload
            </p>
            <p className="ant-upload-hint">Supports multiple file selection.</p>
          </Dragger>
          
          {processingStatus && (
            <div style={{ marginTop: "16px" }}>
              {processingSteps.length > 0 && (
                <div style={{ marginTop: "16px" }}>
                  <h4>Processing Steps:</h4>
                  <ul style={{ listStyle: "none", padding: 0 }}>
                    {processingSteps.map((step, index) => (
                      <li key={index} style={{ marginBottom: "8px" }}>
                        <CheckCircleOutlined style={{ color: "#52c41a", marginRight: "8px" }} />
                        {step}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          )}
          
          <Button
            type="primary"
            onClick={handleUpload}
            loading={loadingUpload}
            disabled={!accessible}
            style={{ marginTop: "16px", width: "100%" }}
          >
            Upload and Identify Codes
          </Button>
        </Card>
      </Col>
    </Row>
  );
};

export default FileUploadSection; 